"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GIRValidationUtils = void 0;
var Product_1 = require("../../tasks/coverpath/dependencies/Product");
var ValidationUtils_1 = require("../ValidationUtils");
var nonTableRatedHealthClasses = [
    'ULTRA',
    'SELECT',
    'STANDARD',
    'SELECT_TOBACCO',
    'STANDARD_TOBACCO'
];
var GIRValidationUtils = /** @class */ (function () {
    function GIRValidationUtils() {
    }
    /*
    based on Insured Age
     */
    GIRValidationUtils.isValidGirAge = function (dateOfBirth) {
        var dob = new Date(dateOfBirth);
        // the min for GIR is 0 so we never check for this
        if (ValidationUtils_1.ValidationUtils.isOlderThanOrEqualToAge(dob, Product_1.RiderConstants.gir.maxAge)) {
            return {
                isValid: false,
                message: "Guaranteed Insurability Rider cannot be added over age ".concat(Product_1.RiderConstants.gir.maxAge)
            };
        }
        return { isValid: true };
    };
    // This function is used by the quotes page, amendments, and admin (when generating a revised basic illustration)
    GIRValidationUtils.validateGirRider = function (dob, faceAmount, girAmount, healthClass) {
        var maxAgeExceeded = false, invalidHealthClass = false, required = false, min, max;
        if (!this.isValidGirAge(dob).isValid) {
            maxAgeExceeded = true;
        }
        else if (!nonTableRatedHealthClasses.includes(healthClass)) {
            invalidHealthClass = true;
        }
        else if (!faceAmount) {
            required = true;
        }
        else if (girAmount < Product_1.RiderConstants.gir.minFace) {
            min = { min: Product_1.RiderConstants.gir.minFace };
        }
        else if (girAmount > Math.min(2 * faceAmount, Product_1.RiderConstants.gir.maxFace)) {
            max = { max: Math.min(2 * faceAmount, Product_1.RiderConstants.gir.maxFace) };
        }
        if (maxAgeExceeded || invalidHealthClass || required || min || max) {
            return {
                gir: {
                    maxAgeExceeded: maxAgeExceeded,
                    invalidHealthClass: invalidHealthClass,
                    required: required,
                    min: min,
                    max: max
                }
            };
        }
        return null;
    };
    return GIRValidationUtils;
}());
exports.GIRValidationUtils = GIRValidationUtils;
